import styled from '@emotion/styled';

import {
  mediaTablet,
  mediaDesktop,
} from '../../functions/media';

const LogoImg = ({ className }) => (
  <svg
    className={className}
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 47 44"
  >
    <path
      d="M43,18.9c-1-2.3-1.6-4.8-1.5-7.3c0.2-2.3,1.1-4.4,2-6.5c-1.6,1.6-2.8,3.7-3.2,6c-0.3,1.8,0.1,3.7,0.6,5.5
		c0.6,1.9,1.6,3.7,2.5,5.5c0.9,1.7,1.9,3.5,1.7,5.5C46,24.6,44,21.4,43,18.9z"
    />
    <path d="M32.4,16.4c0.3,0,0.6-0.3,0.6-0.6c0-0.4-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6C31.8,16.1,32.1,16.4,32.4,16.4z" />
    <path
      d="M21.9,17.9C21.9,17.9,21.9,17.9,21.9,17.9c-0.3-0.2-0.5-0.3-0.6-0.4c1-2.1,2.1-4.1,3.1-6.3
		c0.8-1.8,1.5-3.7,1.6-5.7c0.1-2-0.4-4.1-1.7-5.5c1.4,2.4,1.2,5.5,0.2,8c-1.1,2.6-2.6,4.9-4.1,7.3c-2.1,3.5-4.3,7.3-4.7,11.6
		c-0.4,5.1,2.2,10.5,5.1,14.4c0.3,0.4,0.6,0.8,0.9,1.1c-0.8-1.8-1.5-3.5-2.1-5.3c-0.9-2.6-1.7-5.3-1.9-8.1
		c-0.2-3.7,1.4-7.1,2.9-10.3c0-0.1,0.1-0.1,0.1-0.2c0.7,0.2,4.1,1.5,7,5.3c3.3,4.3,3.7,20,3.7,20s0-11.4,0.2-12.7
		c0.4-3.1,1.4-4.7,5-5.5c3.6-0.8,7.5-0.9,7.5-0.9s-6.2-1.2-12-2.7C27.7,21.1,23.7,18.9,21.9,17.9z"
    />
    <path
      d="M15.6,10.9c-3.8-1.9-6.2-3.7-6.2-3.7l-0.9,2c0,0,1.7,1.2,4.5,2.6C13.9,11.5,14.7,11.1,15.6,10.9z"
      fill="#76B72A"
    />
    <path
      d="M45.9,12.4c0,0,3,2.7-9.6,3.8c-5.8,0.5-12.1-1.4-17.1-3.6c-0.9,0.2-1.8,0.5-2.8,0.9c5.2,2.2,12.4,4.5,20.1,4.1
		C51.6,17,45.9,12.4,45.9,12.4z"
      fill="#76B72A"
    />
    <path
      d="M0,15.9c0,0,3.9-0.1,7.4-1.4s8.5-3.6,11.4-4.1s3.8-0.3,3.8-0.3l-0.4,1.4c0,0-5.3,1-8.7,2.8s-9.9,4.3-12.9,4.5
	C0.3,16.8,0,15.9,0,15.9z"
      fill="#76B72A"
    />
  </svg>
);

const Slim = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 49 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.51123 14.7549L1.25508 13.8955C2.1319 14.6976 2.99793 15.2812 3.85318 15.6465C4.70843 16.0046 5.69305 16.1836 6.80703 16.1836C7.95695 16.1836 8.89486 15.8936 9.62074 15.3135C10.3466 14.7334 10.7096 13.9886 10.7096 13.0791C10.7096 12.5062 10.591 12.0299 10.3538 11.6504C10.1238 11.2708 9.68542 10.9271 9.0386 10.6191C8.39895 10.3112 7.50058 10.0391 6.34347 9.80273C4.48204 9.42318 3.14526 8.89681 2.33313 8.22363C1.52819 7.54329 1.12572 6.6123 1.12572 5.43066C1.12572 4.27767 1.59647 3.31445 2.53796 2.54102C3.47946 1.76758 4.66531 1.38086 6.09552 1.38086C7.18795 1.38086 8.14022 1.53125 8.95235 1.83203C9.76448 2.12565 10.5766 2.59831 11.3887 3.25L10.6664 4.15234C9.95494 3.53646 9.22546 3.09245 8.47801 2.82031C7.73775 2.54818 6.92921 2.41211 6.0524 2.41211C4.93123 2.41211 4.02208 2.69499 3.32494 3.26074C2.6278 3.81934 2.27923 4.52116 2.27923 5.36621C2.27923 5.94629 2.39422 6.42969 2.62421 6.81641C2.86138 7.19596 3.31056 7.55046 3.97177 7.87988C4.64016 8.20215 5.57447 8.48503 6.77469 8.72852C8.56425 9.09375 9.85791 9.61296 10.6557 10.2861C11.4606 10.9593 11.8631 11.8688 11.8631 13.0146C11.8631 14.2464 11.3816 15.2562 10.4185 16.0439C9.45544 16.8245 8.22647 17.2148 6.73157 17.2148C5.51697 17.2148 4.41017 17.0143 3.41118 16.6133C2.41938 16.2122 1.45273 15.5928 0.51123 14.7549Z" />
    <path d="M17.3055 17V0.94043H18.3836V17H17.3055Z" />
    <path d="M24.4405 2.85254V1.38086H25.7772V2.85254H24.4405ZM24.5698 17V5.78516H25.6479V17H24.5698Z" />
    <path d="M31.6724 17V5.78516H32.7613V7.7832C32.9697 7.45378 33.1781 7.16732 33.3865 6.92383C33.595 6.68034 33.8465 6.44759 34.1412 6.22559C34.443 5.99642 34.7916 5.82096 35.1869 5.69922C35.5894 5.57747 36.0314 5.5166 36.5129 5.5166C37.4328 5.5166 38.209 5.74219 38.8415 6.19336C39.4811 6.63737 39.9698 7.21745 40.3076 7.93359C41.2491 6.32227 42.6039 5.5166 44.3719 5.5166C45.7015 5.5166 46.7543 5.94271 47.5305 6.79492C48.3067 7.64714 48.6948 8.78223 48.6948 10.2002V17H47.6168V10.3291C47.6168 9.12598 47.3221 8.18783 46.7328 7.51465C46.1434 6.84147 45.3277 6.50488 44.2856 6.50488C43.2938 6.50488 42.4529 6.86296 41.763 7.5791C41.073 8.29525 40.7281 9.25846 40.7281 10.4688V17H39.65V10.2646C39.65 9.10449 39.3517 8.18783 38.7552 7.51465C38.1659 6.84147 37.3681 6.50488 36.362 6.50488C35.3558 6.50488 34.5041 6.89518 33.807 7.67578C33.1098 8.44922 32.7613 9.40169 32.7613 10.5332V17H31.6724Z" />
  </svg>
);

const Mom = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 54 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.402832 15.4043V0H1.48088L7.69044 9.10938L13.8892 0H14.9781V15.4043H13.8245V2.03027L7.712 10.8926H7.62576L1.50244 2.03027V15.4043H0.402832Z" />
    <path d="M20.3234 9.79688C20.3234 9.01628 20.4708 8.2679 20.7654 7.55176C21.0601 6.83561 21.459 6.21256 21.9621 5.68262C22.4652 5.14551 23.0797 4.7194 23.8055 4.4043C24.5314 4.08203 25.304 3.9209 26.1234 3.9209C27.2086 3.9209 28.1932 4.18945 29.0772 4.72656C29.9684 5.25651 30.6583 5.97266 31.1471 6.875C31.643 7.77018 31.8909 8.74414 31.8909 9.79688C31.8909 10.8424 31.643 11.8128 31.1471 12.708C30.6512 13.6032 29.954 14.3229 29.0556 14.8672C28.1645 15.4043 27.1727 15.6729 26.0802 15.6729C25.2681 15.6729 24.5027 15.5153 23.784 15.2002C23.0653 14.8851 22.4544 14.4626 21.9513 13.9326C21.4482 13.4027 21.0493 12.7796 20.7547 12.0635C20.4672 11.3402 20.3234 10.5846 20.3234 9.79688ZM21.4877 9.79688C21.4877 11.1504 21.9333 12.2998 22.8245 13.2451C23.7229 14.1833 24.8225 14.6523 26.1234 14.6523C26.9427 14.6523 27.7045 14.4375 28.4088 14.0078C29.1131 13.571 29.6737 12.9801 30.0906 12.2354C30.5074 11.4906 30.7158 10.6777 30.7158 9.79688C30.7158 8.45052 30.2631 7.30469 29.3575 6.35938C28.4519 5.4069 27.3595 4.93066 26.0802 4.93066C25.2465 4.93066 24.4775 5.14909 23.7732 5.58594C23.0689 6.01562 22.5119 6.60645 22.1022 7.3584C21.6926 8.10319 21.4877 8.91602 21.4877 9.79688Z" />
    <path d="M36.9776 15.4043V4.18945H38.0664V6.1875C38.2748 5.85807 38.4832 5.57161 38.6917 5.32812C38.9001 5.08464 39.1516 4.85189 39.4463 4.62988C39.7482 4.40072 40.0967 4.22526 40.492 4.10352C40.8945 3.98177 41.3365 3.9209 41.818 3.9209C42.7379 3.9209 43.5141 4.14648 44.1466 4.59766C44.7862 5.04167 45.275 5.62174 45.6127 6.33789C46.5542 4.72656 47.909 3.9209 49.677 3.9209C51.0066 3.9209 52.0595 4.34701 52.8357 5.19922C53.6119 6.05143 54 7.18652 54 8.60449V15.4043H52.9219V8.7334C52.9219 7.53027 52.6272 6.59212 52.0379 5.91895C51.4486 5.24577 50.6329 4.90918 49.5907 4.90918C48.5989 4.90918 47.7581 5.26725 47.0681 5.9834C46.3782 6.69954 46.0332 7.66276 46.0332 8.87305V15.4043H44.9551V8.66895C44.9551 7.50879 44.6569 6.59212 44.0603 5.91895C43.471 5.24577 42.6733 4.90918 41.6671 4.90918C40.6609 4.90918 39.8092 5.29948 39.1121 6.08008C38.415 6.85352 38.0664 7.80599 38.0664 8.9375V15.4043H36.9776Z" />
  </svg>
);

export const LogoFirst = styled(LogoImg)`
  fill: ${props => props.theme.fontColors.secondary};
  width: 46px;
  height: 44px;

  ${mediaDesktop(` 
  width: 70px;
  height:66px;  
`)}
`;
export const LogoSlim = styled(Slim)`
  margin-left: 10px;
  display: block;
  width: 47px;
  height: 16px;
  fill: ${props => props.theme.fontColors.secondary};
  ${mediaDesktop(`
  margin-left:-10px;  
  width: 48px;
  height:18px;
  
`)}
`;
export const LogoMom = styled(Mom)`
  margin-left: 3px;
  display: block;
  width: 47px;
  height: 16px;
  fill: ${props => props.theme.fontColors.buttonSecondary};
  ${mediaDesktop(`  
  width: 54px;
  height: 18px;
`)}
`;

export const LogoContainer = styled.div`
  position: relative;
  height: 44px;
  display: flex;
  align-items: center;
  ${mediaTablet(`
      display:flex;
      align-items: center;
       width: 162px;
  `)}
  ${mediaDesktop(`
      align-items: flex-end;
       width: 167px;
       height: 66px;
       margin-right: 40px;
  `)}
`;
